<script lang="ts">
	import { getRentalTemplateContext } from "./rental-template-context.svelte";
	import { cloudinaryUrl } from "#lib/shared/cloudinary.js";

	const templateContext = getRentalTemplateContext()!;
</script>

<section id="overview" class="relative pt-24 pb-16 text-white">
	<!-- Background image -->
	<div class="absolute inset-0 z-0">
		<img
			src={cloudinaryUrl("rental-template/community-aerial", { width: 1920, quality: 30 })}
			alt="Background"
			class="h-full w-full object-cover"
			width="1920"
			height="1080"
			loading="lazy"
		/>
		<!-- Overlay -->
		<div class="absolute inset-0 bg-[rgb(5,5,5)] opacity-90"></div>
	</div>

	<!-- Content -->
	<div class="relative z-10 container mx-auto px-4">
		<h2 class="mb-6 text-center text-4xl font-medium">{templateContext.welcomeTagline}</h2>
		<hr class="border-primary mx-auto mb-4 w-[100px] border-2" />

		<h3 class="mb-8 text-center text-2xl text-[rgb(222,208,192)]">
			{templateContext.welcomeTagline}
		</h3>

		<div class="mx-auto max-w-3xl text-center">
			<p class="mb-4 text-lg leading-relaxed">
				{templateContext.welcomeDescription}
			</p>
		</div>
	</div>
</section>
